export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'it', label: 'Italiano' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'pl', label: 'Polski' },
  { code: 'pt', label: 'Português' },
  { code: 'el', label: 'Ελληνικά' },
  { code: 'sv', label: 'Svenska' },
  { code: 'da', label: 'Dansk' },
  { code: 'fi', label: 'Suomi' },
  { code: 'no', label: 'Norsk' },
  { code: 'cs', label: 'Čeština' },
  { code: 'hu', label: 'Magyar' },
  { code: 'ro', label: 'Română' },
  { code: 'bg', label: 'Български' },
  { code: 'hr', label: 'Hrvatski' },
  { code: 'lt', label: 'Lietuvių' },
  { code: 'lv', label: 'Latviešu' },
  { code: 'et', label: 'Eesti' },
  { code: 'zhCN', label: '中文' },
  { code: 'ar', label: 'العربية' },
  // { code: 'hi', label: 'हिन्दी' },
];

export const uiText: Record<string, Record<string, string>> = {
  en: {
    title: 'NHE News',
    language: 'Language',
    city: 'City',
    save: 'Save',
    cancel: 'Cancel',
    todaysTop: "Today's Top",
    olderDays: 'Older Days',
    changePrefs: 'Change preferences',
    loading: 'Loading...',
    chooseNewsCategory: 'Choose News Category',
  },
  fr: {
    title: 'NHE News',
    language: 'Langue',
    city: 'Ville',
    save: 'Enregistrer',
    cancel: 'Annuler',
    todaysTop: 'Top du jour',
    olderDays: 'Jours précédents',
    changePrefs: 'Modifier les préférences',
    loading: 'Chargement...',
    chooseNewsCategory: 'Choisir une catégorie de news',
  },
  de: {
    title: 'NHE News',
    language: 'Sprache',
    city: 'Stadt',
    save: 'Speichern',
    cancel: 'Abbrechen',
    todaysTop: 'Top heute',
    olderDays: 'Ältere Tage',
    changePrefs: 'Einstellungen ändern',
    loading: 'Lädt...',
    chooseNewsCategory: 'Nachrichtenkategorie auswählen',
  },
  es: {
    title: 'NHE Noticias',
    language: 'Idioma',
    city: 'Ciudad',
    save: 'Guardar',
    cancel: 'Cancelar',
    todaysTop: 'Top de Hoy',
    olderDays: 'Días Anteriores',
    changePrefs: 'Cambiar preferencias',
    loading: 'Cargando...',
    chooseNewsCategory: 'Elegir categoría de noticias',
  },
  it: {
    title: 'NHE News',
    language: 'Lingua',
    city: 'Città',
    save: 'Salva',
    cancel: 'Annulla',
    todaysTop: 'Top di oggi',
    olderDays: 'Giorni precedenti',
    changePrefs: 'Cambia preferenze',
    loading: 'Caricamento...',
    chooseNewsCategory: 'Scegli categoria di notizie',
  },
  nl: {
    title: 'NHE News',
    language: 'Taal',
    city: 'Stad',
    save: 'Opslaan',
    cancel: 'Annuleren',
    todaysTop: 'Top vandaag',
    olderDays: 'Oudere dagen',
    changePrefs: 'Voorkeuren wijzigen',
    loading: 'Laden...',
    chooseNewsCategory: 'Nieuwscategorie kiezen',
  },
  pl: {
    title: 'NHE News',
    language: 'Język',
    city: 'Miasto',
    save: 'Zapisz',
    cancel: 'Anuluj',
    todaysTop: 'Najważniejsze dziś',
    olderDays: 'Starsze dni',
    changePrefs: 'Zmień ustawienia',
    loading: 'Ładowanie...',
    chooseNewsCategory: 'Wybierz kategorię wiadomości',
  },
  pt: {
    title: 'NHE News',
    language: 'Idioma',
    city: 'Cidade',
    save: 'Salvar',
    cancel: 'Cancelar',
    todaysTop: 'Destaques de hoje',
    olderDays: 'Dias anteriores',
    changePrefs: 'Alterar preferências',
    loading: 'Carregando...',
    chooseNewsCategory: 'Escolher categoria de notícias',
  },
  el: {
    title: 'NHE News',
    language: 'Γλώσσα',
    city: 'Πόλη',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    todaysTop: 'Κορυφαία Σήμερα',
    olderDays: 'Παλαιότερες ημέρες',
    changePrefs: 'Αλλαγή προτιμήσεων',
    loading: 'Φόρτωση...',
    chooseNewsCategory: 'Επιλογή κατηγορίας ειδήσεων',
  },
  sv: {
    title: 'NHE News',
    language: 'Språk',
    city: 'Stad',
    save: 'Spara',
    cancel: 'Avbryt',
    todaysTop: 'Dagens topp',
    olderDays: 'Äldre dagar',
    changePrefs: 'Ändra inställningar',
    loading: 'Laddar...',
    chooseNewsCategory: 'Välj nyhetskategori',
  },
  da: {
    title: 'NHE News',
    language: 'Sprog',
    city: 'By',
    save: 'Gem',
    cancel: 'Annuller',
    todaysTop: 'Dagens top',
    olderDays: 'Ældre dage',
    changePrefs: 'Skift præferencer',
    loading: 'Indlæser...',
    chooseNewsCategory: 'Vælg nyhedskategori',
  },
  fi: {
    title: 'NHE News',
    language: 'Kieli',
    city: 'Kaupunki',
    save: 'Tallenna',
    cancel: 'Peruuta',
    todaysTop: 'Tämän päivän top',
    olderDays: 'Vanhemmat päivät',
    changePrefs: 'Vaihda asetuksia',
    loading: 'Ladataan...',
    chooseNewsCategory: 'Valitse uutiskategoria',
  },
  no: {
    title: 'NHE News',
    language: 'Språk',
    city: 'By',
    save: 'Lagre',
    cancel: 'Avbryt',
    todaysTop: 'Dagens topp',
    olderDays: 'Eldre dager',
    changePrefs: 'Endre preferanser',
    loading: 'Laster...',
    chooseNewsCategory: 'Velg nyhetskategori',
  },
  cs: {
    title: 'NHE News',
    language: 'Jazyk',
    city: 'Město',
    save: 'Uložit',
    cancel: 'Zrušit',
    todaysTop: 'Nejlepší dnes',
    olderDays: 'Starší dny',
    changePrefs: 'Změnit nastavení',
    loading: 'Načítání...',
    chooseNewsCategory: 'Vybrat kategorii zpráv',
  },
  hu: {
    title: 'NHE News',
    language: 'Nyelv',
    city: 'Város',
    save: 'Mentés',
    cancel: 'Mégse',
    todaysTop: 'Mai toplista',
    olderDays: 'Régebbi napok',
    changePrefs: 'Beállítások módosítása',
    loading: 'Betöltés...',
    chooseNewsCategory: 'Hírkategória kiválasztása',
  },
  ro: {
    title: 'NHE News',
    language: 'Limba',
    city: 'Oraș',
    save: 'Salvează',
    cancel: 'Anulează',
    todaysTop: 'Topul zilei',
    olderDays: 'Zile anterioare',
    changePrefs: 'Schimbă preferințele',
    loading: 'Se încarcă...',
    chooseNewsCategory: 'Alege categoria de știri',
  },
  bg: {
    title: 'NHE News',
    language: 'Език',
    city: 'Град',
    save: 'Запази',
    cancel: 'Отказ',
    todaysTop: 'Днес водещи',
    olderDays: 'По-стари дни',
    changePrefs: 'Промени предпочитания',
    loading: 'Зареждане...',
    chooseNewsCategory: 'Избор на новинарска категория',
  },
  hr: {
    title: 'NHE News',
    language: 'Jezik',
    city: 'Grad',
    save: 'Spremi',
    cancel: 'Odustani',
    todaysTop: 'Danas top',
    olderDays: 'Stariji dani',
    changePrefs: 'Promijeni postavke',
    loading: 'Učitavanje...',
    chooseNewsCategory: 'Odaberite kategoriju vijesti',
  },
  lt: {
    title: 'NHE News',
    language: 'Kalba',
    city: 'Miestas',
    save: 'Išsaugoti',
    cancel: 'Atšaukti',
    todaysTop: 'Šiandienos viršūnė',
    olderDays: 'Senesnės dienos',
    changePrefs: 'Keisti nustatymus',
    loading: 'Kraunama...',
    chooseNewsCategory: 'Pasirinkti naujienų kategoriją',
  },
  lv: {
    title: 'NHE News',
    language: 'Valoda',
    city: 'Pilsēta',
    save: 'Saglabāt',
    cancel: 'Atcelt',
    todaysTop: 'Šodienas top',
    olderDays: 'Vecākas dienas',
    changePrefs: 'Mainīt preferences',
    loading: 'Ielādē...',
    chooseNewsCategory: 'Izvēlēties ziņu kategoriju',
  },
  et: {
    title: 'NHE News',
    language: 'Keel',
    city: 'Linn',
    save: 'Salvesta',
    cancel: 'Tühista',
    todaysTop: 'Tänane tipp',
    olderDays: 'Vanemad päevad',
    changePrefs: 'Muuda eelistusi',
    loading: 'Laadimine...',
    chooseNewsCategory: 'Vali uudiste kategooria',
  },
  zhCN: {
    title: 'NHE 新闻',
    language: '语言',
    city: '城市',
    save: '保存',
    cancel: '取消',
    todaysTop: '今日头条',
    olderDays: '往期新闻',
    changePrefs: '修改偏好设置',
    loading: '加载中...',
    chooseNewsCategory: '选择新闻分类',
  },
  ar: {
    title: 'أخبار NHE',
    language: 'اللغة',
    city: 'المدينة',
    save: 'حفظ',
    cancel: 'إلغاء',
    todaysTop: 'أهم أخبار اليوم',
    olderDays: 'الأيام السابقة',
    changePrefs: 'تغيير التفضيلات',
    loading: 'جارٍ التحميل...',
    chooseNewsCategory: 'اختر فئة الأخبار',
  },
};
